import React from "react";

import { useLabels } from "../../hooks/useLabels";
import { labels } from "./labels";
import { OrientationBlockerContent } from "./orientation-blocker-content";

export const OrientationBlockerContentContainer = () => {
	const [[message], loading] = useLabels([labels.orientationNotSupported]);

	return <OrientationBlockerContent>{loading ? null : message}</OrientationBlockerContent>;
};
OrientationBlockerContentContainer.displayName = "OrientationBlockerContentContainer";
